<template>
    <div id="allOffers">
        <div v-if="isLoaded">
            <template v-if="offers.length > 0">
                <div class="form-group">
                    <label>{{ $t("manager.offerlist.filterById") }}:</label>
                    <input type="text" class="form-control" v-model="search">
                </div>
                <table class="table table-striped">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">{{ $t("offer.title") | capitalize-first }}</th>
                            <th scope="col">{{ $t("offer.customer") | capitalize-first }}</th>
                            <th scope="col">{{ $t("offer.dates.offer") }}</th>
                            <th scope="col">{{ $t("offer.dates.valid") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="offer in filteredOffers.slice().reverse()" :key="offer.hash" :to="{ name: 'offer', params: { id: offer.hash }}" exact>
                            <th scope="row">
                                <router-link :to="{ name: 'offer', params: { id: offer.hash }}">
                                    <strong >{{ offer.id }}</strong>
                                </router-link>
                            </th>
                            <td>{{ offer.customer.name }}</td>
                            <td><template v-if="offer.dates.offer.length > 0">{{ $d(new Date(offer.dates.offer), 'short', 'fi-FI') }}</template></td>
                            <td><template v-if="offer.dates.valid.length > 0">{{ $d(new Date(offer.dates.valid), 'short', 'fi-FI') }}</template></td>
                        </tr>
                    </tbody>
                </table>
            </template>
            <template v-else>
                <div class="alert alert-warning">
                    {{ $t("noRows") }}
                </div>
            </template>
        </div>
        <div v-else class="offer m-3 p-3 border rounded">
            <div class="text-center">
                <font-awesome-icon icon="spinner" pulse />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Offer',
  data () {
    return {
      isLoaded: false,
      offers: [],
      search: ''
    }
  },
  methods: {
    loadOfferList: function () {
      let me = this
      axios.get(me.$store.getters.urlPath + 'services/manager/getOfferList.php')
        .then(function (response) {
          me.offers = response.data
          me.isLoaded = true
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  },
  computed: {
    filteredOffers () {
      if (this.search.length > 0) {
        return this.offers.filter(item => {
          return item.id.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            item.customer.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      } else {
        return this.offers
      }
    }
  },
  mounted () {
    this.loadOfferList()
  }
}
</script>
